// TODO: This file was created by bulk-decaffeinate.
// Fix any style issues and re-enable lint.
/*
 * decaffeinate suggestions:
 * DS101: Remove unnecessary use of Array.from
 * DS102: Remove unnecessary code created because of implicit returns
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */

import { isTouch } from '@trello/browser';
// eslint-disable-next-line no-restricted-imports
import $ from '@trello/jquery';
import { getKey, isArrow, Key } from '@trello/keybindings';

import { Util } from 'app/scripts/lib/util';
import { PopOver } from 'app/scripts/views/lib/PopOver';
import { stopPropagationAndPreventDefault } from 'app/src/stopPropagationAndPreventDefault';

// Mixin
// eslint-disable-next-line @trello/enforce-variable-case
const AutoInsertionView = {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  checkInsert(e: any) {
    const key = getKey(e);

    if (PopOver.isVisible && !isTouch()) {
      if (
        (e.shiftKey && [Key.ArrowUp, Key.ArrowDown].includes(key)) ||
        (e.altKey && [Key.ArrowUp, Key.ArrowDown].includes(key))
      ) {
        return;
      } else if (key === Key.Escape) {
        stopPropagationAndPreventDefault(e);
        PopOver.hide();
        return;
      } else {
        const autoCompleters = [
          {
            listClass: '.js-available-members',
            itemClass: '.js-select-member',
          },
          { listClass: '.js-available-emoji', itemClass: '.js-select-emoji' },
          { listClass: '.js-card-list', itemClass: '.js-select-card' },
        ];

        for (const { listClass, itemClass } of Array.from(autoCompleters)) {
          // eslint-disable-next-line @trello/enforce-variable-case
          let $available = $('.pop-over').find(listClass);
          if ($available.length > 0) {
            if ([Key.Enter, Key.Tab].includes(key)) {
              stopPropagationAndPreventDefault(e);
              // Make sure we've updated the list with everything we've typed
              if ($available.find('.item:first').hasClass('selected')) {
                this.keyAutoMention(e);
                // This might cause the list to re-write, so we have to get the
                // items back out of the DOM
                $available = $('.pop-over').find(listClass);
              }

              $available
                .find(`.item.selected:first ${itemClass}`)
                .first()
                .click();

              PopOver.hide();
              return false;
            } else if ([Key.ArrowUp, Key.ArrowDown].includes(key)) {
              stopPropagationAndPreventDefault(e);
              Util.navMenuList($available, '.item', key);
              return false;
            }
          }
        }
      }
    }
  },

  // @ts-expect-error TS(7023): 'keyAutoMention' implicitly has return type 'any' ... Remove this comment to see the full error message
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  keyAutoMention(e: any) {
    if (!isTouch()) {
      if (isArrow(getKey(e)) || getKey(e) === Key.Enter) {
        return;
      }

      if (getKey(e) === Key.Escape) {
        if (PopOver.isVisible) {
          stopPropagationAndPreventDefault(e);
        }
        return;
      }

      // @ts-expect-error TS(2339): Property 'getTextInput' does not exist on type '{ ... Remove this comment to see the full error message
      const word = Util.getWordFromCaret(this.getTextInput());

      if (new RegExp(`^@\\S`).test(word.str.substring(0, 2))) {
        // Because the function that determines who to show is
        // locked up in the view, we need to load the view first
        // to determine if there is anything to show in the popover.
        // We won't show it if there isn't anybody that matches.

        // @ts-expect-error TS(2339): Property 'getAutoMentionerView' does not exist on ... Remove this comment to see the full error message
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        return this.getAutoMentionerView('input').then((view: any) => {
          if (
            view.filterMentionablesForMatches(
              word.str.substring(1).toLowerCase(),
            ).length === 0
          ) {
            PopOver.hide();
            return;
          }

          PopOver.show({
            // @ts-expect-error TS(2339): Property 'getMentionTarget' does not exist on type... Remove this comment to see the full error message
            elem: this.getMentionTarget(),
            view,
            keepEdits: true,
          });

          // @ts-expect-error TS(2339): Property 'getTextInput' does not exist on type '{ ... Remove this comment to see the full error message
          if (!this.getTextInput().is(':focus')) {
            // @ts-expect-error TS(2339): Property 'getTextInput' does not exist on type '{ ... Remove this comment to see the full error message
            this.getTextInput().focus();
          }
        });
      } else if (/^:[a-z0-9_]+$/.test(word.str)) {
        // @ts-expect-error TS(2339): Property 'getEmojiCompleterView' does not exist on... Remove this comment to see the full error message
        const emojiView = this.getEmojiCompleterView('input');

        PopOver.show({
          // @ts-expect-error TS(2339): Property 'getEmojiTarget' does not exist on type '... Remove this comment to see the full error message
          elem: this.getEmojiTarget(),
          view: emojiView,
          keepEdits: true,
        });

        // @ts-expect-error TS(2339): Property 'getTextInput' does not exist on type '{ ... Remove this comment to see the full error message
        if (!this.getTextInput().is(':focus')) {
          // @ts-expect-error TS(2339): Property 'getTextInput' does not exist on type '{ ... Remove this comment to see the full error message
          this.getTextInput().focus();
        }
        return;
      }

      // @ts-expect-error TS(2339): Property 'setTimeout' does not exist on type '{ ch... Remove this comment to see the full error message
      return this.setTimeout(() => PopOver.hide(), 5);
    }
  },
};

export { AutoInsertionView };
